import { api } from "@/utils/api";
import { 
  Workflow, 
  WorkflowCreateRequest, 
  WorkflowCreateResponse,
  WorkflowUpdateRequest,
  WorkflowUpdateResponse
} from "@/types/workflow";


export const workflowApi = {
  create: async (data: WorkflowCreateRequest): Promise<WorkflowCreateResponse> => {
    const response = await api.post<WorkflowCreateResponse>("/workflow", data);
    return response.data;
  },

  getAll: async (): Promise<Workflow[]> => {
    const response = await api.get<Workflow[]>("/workflow");
    return response.data;
  },

  getById: async (id: string): Promise<Workflow> => {
    const response = await api.get<Workflow>(`/workflow/${id}`);
    return response.data;
  },

  update: async (id: string, data: WorkflowUpdateRequest): Promise<WorkflowUpdateResponse> => {
    const response = await api.put<WorkflowUpdateResponse>(`/workflow/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<{ message: string }> => {
    const response = await api.delete(`/workflow/${id}`);
    return response.data;
  },
};